export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13439.db714419.jpg";